import { render, staticRenderFns } from "./LightboxNavButton.vue?vue&type=template&id=6ee35c97&"
import script from "./LightboxNavButton.vue?vue&type=script&lang=js&"
export * from "./LightboxNavButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports